export default __webpack_public_path__ + "static/PremiumBg-80fb0633900b1b313d83832772871574.png";